import { createLoadingSpinnerComponent, LoadingSpinner } from '@vfde-brix/loading-spinner';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { WRAPPER_ID_LOADING_SPINNER } from '../constant';
import { getGigacubeObjectProperty, setGigacubeObjectProperty } from '../helper/windowObjectHelper';

/**
 * Mount LoadingSpinner BRIX component
 */
export const mountLoadingSpinner = (): LoadingSpinner | null => {
    const containerEl = document.getElementById(WRAPPER_ID_LOADING_SPINNER);

    if (!containerEl) {
        return null;
    }

    const loadingSpinner = createLoadingSpinnerComponent(containerEl, {
        optIsVisible: false,
        business: NO_PATTERN_BUSINESS_LOGIC,
    });

    setGigacubeObjectProperty(
        WRAPPER_ID_LOADING_SPINNER,
        loadingSpinner
    );

    return loadingSpinner;
};

/**
 * Toggle loading spinner
 */
export const showLoadingSpinner = (show: boolean = true) => {
    const loadingSpinner: LoadingSpinner | undefined = getGigacubeObjectProperty(WRAPPER_ID_LOADING_SPINNER);

    show ? loadingSpinner?.show() : loadingSpinner?.hide();
};
